module.exports = "<button class=\"hamburger hamburger--elastic\" [class.is-active]=\"burgerFlipped\"  (click)=\"flipBurger()\" type=\"button\" aria-label=\"menu\">\n  <span class=\"hamburger-box\">\n    <span class=\"hamburger-inner\"></span>\n  </span>\n  <span class=\"hamburger-title\">Menu</span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/hamburger/hamburger.component.html
// module id = ../../../../../src/app/components/hamburger/hamburger.component.html
// module chunks = main